import React from "react";

export const Interest = () => {
  return <>Interest Mine</>;
};
